<template>
  <div class="row">
    <div class="col-12 mb-15">
      <h4 class="text-center" style="color: #f58818">FORM8維護</h4>
      <form class="form">
        <div class="panel panel-form searchArea">
          <!-- FORM類型 -->
          <div class="form-group row">
            <label class="col-2 text-right">FORM類型</label>
            <div class="col-10 d-inline-grid">
              <!-- FORM類型-1 -->
              <div
                v-for="(item, index) in formTypeList"
                :key="`formType-${item.value}`"
                class="radio d-flex ml-15 mb-15"
              >
                <input
                  type="radio"
                  :id="`formType-${index}`"
                  v-model="formType"
                  :value="item.value"
                  @change="formTypeChange()"
                />
                <label class="hide-label" :for="`formType-${index}`"></label>
                <span class="lh-40">{{ item.text }}</span>
              </div>
            </div>
          </div>

          <!-- 上傳檔案 -->
          <div class="form-group row">
            <label class="col-2 text-right">上傳檔案</label>
            <div class="col-10 d-inline-grid">
              <!-- 保障公式-1 -->
              <div class="ml-15 mb-15">
                <input
                  type="file"
                  id="actual-btn"
                  accept=".csv, .txt"
                  @change="fileChange"
                  hidden
                />
                <label for="actual-btn" class="btn btn-default btn-sm">
                  選擇檔案
                </label>
                <span class="lh-40">{{ fileValue }}</span>
              </div>
            </div>
          </div>

          <div class="text-center">
            <button type="button" class="btn btn-primary" @click="doImport">
              開始匯入
            </button>
            <button
              type="button"
              class="btn btn-default"
              @click="$router.go(-1)"
            >
              返回
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12">
      <div class="mb-15 mt-40" v-if="this.importResult">
        <span class="text-red">{{
          `上傳記錄：這個商品【${productData.insuranceName}】的【${
            this.formKind
          }型】【Form8】已由【${this.$store.state.userInfo.name}】於【${moment(
            new Date()
          ).format("YYYY/MM/DD HH:mm:ss")}】上傳${
            this.importResult
          }，匯入共計【${this.importCount}】筆資料；`
        }}</span>
      </div>
      <div class="mb-15" v-if="this.form8Data.length">
        <span>匯入成功前10筆資料：</span>
      </div>
      <table class="table datatable mb-15" v-if="this.form8Data.length">
        <thead>
          <tr>
            <th width="5" class="text-center">NO</th>
            <th width="10" class="text-center">種類</th>
            <th width="70" class="text-center">險種代碼</th>
            <th width="70" class="text-center">投保年齡</th>
            <th width="10" class="text-center">性別</th>
            <th width="70" class="text-center">繳費年期</th>
            <th width="70" class="text-center">經過年度</th>
            <th width="100" class="text-center">
              {{
                this.pageName == "身故及完全失能保險金"
                  ? "一般身故保額金"
                  : "暫無使用"
              }}
            </th>
            <th width="100" class="text-center">
              {{
                this.pageName == "身故及完全失能保險金"
                  ? "疾病身故保險金"
                  : "暫無使用"
              }}
            </th>
            <th width="100" class="text-center">
              {{
                this.pageName == "身故及完全失能保險金"
                  ? "意外身故保險金"
                  : "生存保險金"
              }}
            </th>
            <th width="70" class="text-center">保額單位</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, i) in this.form8Data.slice(0, 10)"
            :key="`form8-data-${i}`"
          >
            <td>0</td>
            <td class="text-center">{{ item.deathbenefit_kind }}</td>
            <td class="text-center">{{ item.insurance_code }}</td>
            <td class="text-center">{{ item.insure_age }}</td>
            <td class="text-center">{{ item.sex }}</td>
            <td class="text-center">{{ item.payment_period }}</td>
            <td class="text-center">{{ item.year }}</td>
            <td class="text-right">
              {{
                item.general_death_benefit
                  ? item.general_death_benefit.toFixed(4)
                  : Number(0).toFixed(4)
              }}
            </td>
            <td class="text-right">
              {{
                item.disease_death_benefit
                  ? item.disease_death_benefit.toFixed(4)
                  : Number(0).toFixed(4)
              }}
            </td>
            <td class="text-right">
              {{
                item.accident_death_benefit
                  ? item.accident_death_benefit.toFixed(4)
                  : Number(0).toFixed(4)
              }}
            </td>
            <td class="text-center">{{ item.insurance_amount_unit }}</td>
          </tr>
        </tbody>
      </table>
      <div class="mb-15" v-if="this.form8Data.length">
        <span>格式錯誤前10筆資料：</span>
      </div>
      <table class="table datatable" v-if="this.importResult">
        <thead>
          <tr>
            <th width="5" class="text-center">NO</th>
            <th width="100" class="text-center">原始字串</th>
            <th width="100" class="text-center">訊息</th>
          </tr>
        </thead>
        <tbody v-if="this.uploadFileErr.length">
          <tr
            v-for="(item, i) in this.uploadFileErr.slice(0, 10)"
            :key="`form8Err-data-${i}`"
          >
            <td class="text-center">{{ item.no }}</td>
            <td class="text-center">{{ item.raw.toString() }}</td>
            <td class="text-center">{{ item.message }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="text-center" colspan="3">
              <h4 class="mb-3">【無資料】</h4>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <mv-mask :open="mvMaskOpen" :content="mvMaskContent" />
  </div>
</template>

<script>
import { batchInsertForm8, getForm8Data, deleteForm8Data } from "@/service";
import { commonMixin } from "@/mixins/common";
import MvMask from "@/desktop/views/mv/components/mvMask";
export default {
  mixins: [commonMixin],
  name: "MaintainForm8",
  data() {
    return {
      productData: "",
      pageName: "",
      formType: "1",
      formTypeList: [],
      formKind: "",
      productId: "",
      fileValue: "未選擇任何檔案",
      uploadFile: "",
      uploadFileErr: [],
      rawArray: [],
      form8Data: [],
      importResult: "",
      importCount: "",
      mvMaskContent: "",
      mvMaskOpen: false,
    };
  },
  components: {
    MvMask,
  },
  methods: {
    init() {
      if (this.pageName == "生存保險金") {
        this.formTypeList.push({
          text: "CSR 903A型(格式與903相同 for生存保障專用)",
          value: "1",
        });
        this.formKind = "903A";
      } else if (this.pageName == "滿期保險金") {
        this.formTypeList.push({
          text: "CSR 903B型",
          value: "1",
        });
        this.formKind = "903B";
      } else if (this.pageName == "祝壽金") {
        this.formTypeList.push({
          text: "CSR 903C型",
          value: "1",
        });
        this.formKind = "903C";
      } else if (this.pageName == "身故及完全失能保險金") {
        this.formTypeList.push({
          text: "舊機D型",
          value: "1",
        });
        this.formTypeList.push({
          text: "CSR 902D型",
          value: "2",
        });
        this.formTypeList.push({
          text: "CSR 903型",
          value: "3",
        });
      }
      this.getForm8Data();
    },
    formTypeChange() {
      if (this.pageName == "身故及完全失能保險金") {
        if (this.formType == "1") {
          this.formKind = "D";
        } else if (this.formType == "2") {
          this.formKind = "902D";
        } else if (this.formType == "3") {
          this.formKind = "903";
        }
      }
    },
    fileChange(e) {
      // 可接受的附檔名
      var validExts = new Array(".csv", ".txt");

      var fileExt = e.target.value;
      fileExt = fileExt.substring(fileExt.lastIndexOf("."));
      if (validExts.indexOf(fileExt.toLowerCase()) < 0) {
        this.$toast.info({ title: "檔案格式不支援" });
        return false;
      } else {
        this.fileValue = e.target.files[0].name;
        this.uploadFile = e.target.files[0];
      }
    },
    // 檔案匯入
    async doImport() {
      if (!this.uploadFile) {
        this.$toast.info({ title: "未選擇任何檔案匯入" });
        return;
      } else {
        this.mvMaskContent = "檔案匯入中，請稍候...";
        this.panelOpen("mvMaskOpen");
        //讀取CSV並轉換成array
        const res = await this.readCSV(this.uploadFile);
        this.rawArray = res.split("\r\n");
        this.rawArray.forEach((item, index) => {
          if (!item.trim()) {
            return;
          }
          if (
            this.formKind === "903" ||
            this.formKind === "903A" ||
            this.formKind === "903B" ||
            this.formKind === "903C"
          ) {
            if ((item.match(/,/g) || []).length != 8) {
              this.uploadFileErr.push({
                no: index + 1,
                raw: this.rawArray[index],
                message: `CSR ${this.formKind}型-欄位需為9欄位`,
              });
            }
          } else if (this.formKind === "902D") {
            if ((item.match(/,/g) || []).length != 9) {
              this.uploadFileErr.push({
                no: index + 1,
                raw: this.rawArray[index],
                message: `CSR ${this.formKind}型-欄位需為10欄位`,
              });
            }
          } else if (this.formKind === "D") {
            if (item.length != 36 && item.split("\t").length != 8) {
              this.uploadFileErr.push({
                no: index + 1,
                raw: this.rawArray[index],
                message: `舊機D型-長度需為36碼或欄位需為8欄位`,
              });
            }
          }
        });
        let datas;
        if (
          this.formKind === "903" ||
          this.formKind === "903A" ||
          this.formKind === "903B" ||
          this.formKind === "903C"
        ) {
          datas = this.rawArray.map((x) => {
            const {
              0: INSURANCE_CODE,
              1: INSURE_AGE,
              2: SEX,
              3: PAYMENT_PERIOD,
              4: TYPE1,
              5: TYPE2,
              6: YEAR,
              7: DISEASE_DEATH_BENEFIT,
              8: INSURANCE_AMOUNT_UNIT,
            } = x.split(",");
            return {
              INSURANCE_CODE,
              INSURE_AGE,
              SEX,
              PAYMENT_PERIOD,
              TYPE1,
              TYPE2,
              YEAR,
              DISEASE_DEATH_BENEFIT,
              INSURANCE_AMOUNT_UNIT,
            };
          });
          //若最後一行有換行符號，則下一行會被程式誤判為一筆資料
          if (
            !datas[datas.length - 1].INSURANCE_CODE &&
            !datas[datas.length - 1].INSURE_AGE &&
            !datas[datas.length - 1].SEX &&
            !datas[datas.length - 1].PAYMENT_PERIOD &&
            !datas[datas.length - 1].TYPE1 &&
            !datas[datas.length - 1].TYPE2 &&
            !datas[datas.length - 1].YEAR &&
            !datas[datas.length - 1].DISEASE_DEATH_BENEFIT &&
            !datas[datas.length - 1].INSURANCE_AMOUNT_UNIT
          ) {
            datas.pop();
          }
        } else if (this.formKind === "902D") {
          datas = this.rawArray.map((x) => {
            const {
              0: DEATHBENEFIT_KIND,
              1: INSURANCE_CODE,
              2: PAYMENT_PERIOD,
              3: INSURE_AGE,
              4: SEX,
              5: YEAR,
              6: TYPE1,
              7: DISEASE_DEATH_BENEFIT,
              8: ACCIDENT_DEATH_BENEFIT,
              9: INSURANCE_AMOUNT_UNIT,
            } = x.split(",");
            return {
              DEATHBENEFIT_KIND,
              INSURANCE_CODE,
              PAYMENT_PERIOD,
              INSURE_AGE,
              SEX,
              YEAR,
              TYPE1,
              DISEASE_DEATH_BENEFIT,
              ACCIDENT_DEATH_BENEFIT,
              INSURANCE_AMOUNT_UNIT,
            };
          });
          //若最後一行有換行符號，則下一行會被程式誤判為一筆資料
          if (
            !datas[datas.length - 1].DEATHBENEFIT_KIND &&
            !datas[datas.length - 1].INSURANCE_CODE &&
            !datas[datas.length - 1].PAYMENT_PERIOD &&
            !datas[datas.length - 1].INSURE_AGE &&
            !datas[datas.length - 1].SEX &&
            !datas[datas.length - 1].YEAR &&
            !datas[datas.length - 1].TYPE1 &&
            !datas[datas.length - 1].DISEASE_DEATH_BENEFIT &&
            !datas[datas.length - 1].ACCIDENT_DEATH_BENEFIT &&
            !datas[datas.length - 1].INSURANCE_AMOUNT_UNIT
          ) {
            datas.pop();
          }
        } else if (this.formKind === "D") {
          datas = this.rawArray.map((x) => {
            if (x.length == 36) {
              const DEATHBENEFIT_KIND = x.substr(0, 1);
              const INSURANCE_CODE = x.substr(1, 2);
              const PAYMENT_PERIOD = x.substr(3, 2);
              const INSURE_AGE = x.substr(5, 2);
              const SEX = x.substr(7, 1);
              const YEAR = x.substr(8, 3);
              const TYPE1 = x.substr(11, 1);
              const TYPE2 = x.substr(12, 4);
              const GENERAL_DEATH_BENEFIT = x
                .substr(16, 8)
                .concat(".", x.substr(24, 2));
              const ACCIDENT_DEATH_BENEFIT = x
                .substr(26, 8)
                .concat(".", x.substr(34, 2));
              const INSURANCE_AMOUNT_UNIT =
                this.productData.currency == 1 ? "4" : "3";
              return {
                DEATHBENEFIT_KIND,
                INSURANCE_CODE,
                PAYMENT_PERIOD,
                INSURE_AGE,
                SEX,
                YEAR,
                TYPE1,
                TYPE2,
                GENERAL_DEATH_BENEFIT,
                ACCIDENT_DEATH_BENEFIT,
                INSURANCE_AMOUNT_UNIT,
              };
            } else {
              const {
                0: DEATHBENEFIT_KIND,
                1: INSURANCE_CODE,
                2: PAYMENT_PERIOD,
                3: INSURE_AGE,
                4: SEX,
                5: YEAR,
                6: GENERAL_DEATH_BENEFIT,
                7: ACCIDENT_DEATH_BENEFIT,
              } = x.split("\t");
              const INSURANCE_AMOUNT_UNIT =
                this.productData.currency == 1 ? "4" : "3";
              return {
                DEATHBENEFIT_KIND,
                INSURANCE_CODE,
                PAYMENT_PERIOD,
                INSURE_AGE,
                SEX,
                YEAR,
                GENERAL_DEATH_BENEFIT,
                ACCIDENT_DEATH_BENEFIT,
                INSURANCE_AMOUNT_UNIT,
              };
            }
          });
          //若最後一行有換行符號，則下一行會被程式誤判為一筆資料
          if (Object.keys(datas[datas.length - 1]).length == 11) {
            if (
              !datas[datas.length - 1].DEATHBENEFIT_KIND &&
              !datas[datas.length - 1].INSURANCE_CODE &&
              !datas[datas.length - 1].PAYMENT_PERIOD &&
              !datas[datas.length - 1].INSURE_AGE &&
              !datas[datas.length - 1].SEX &&
              !datas[datas.length - 1].YEAR &&
              !datas[datas.length - 1].TYPE1 &&
              !datas[datas.length - 1].TYPE2 &&
              !datas[datas.length - 1].GENERAL_DEATH_BENEFIT &&
              !datas[datas.length - 1].ACCIDENT_DEATH_BENEFIT &&
              !datas[datas.length - 1].INSURANCE_AMOUNT_UNIT
            ) {
              datas.pop();
            }
          } else {
            if (
              !datas[datas.length - 1].DEATHBENEFIT_KIND &&
              !datas[datas.length - 1].INSURANCE_CODE &&
              !datas[datas.length - 1].PAYMENT_PERIOD &&
              !datas[datas.length - 1].INSURE_AGE &&
              !datas[datas.length - 1].SEX &&
              !datas[datas.length - 1].YEAR &&
              !datas[datas.length - 1].GENERAL_DEATH_BENEFIT &&
              !datas[datas.length - 1].ACCIDENT_DEATH_BENEFIT &&
              !datas[datas.length - 1].INSURANCE_AMOUNT_UNIT
            ) {
              datas.pop();
            }
          }
        }
        //檢核資料格式
        datas = this.validateDatas(datas);

        //發送API請求內容
        const req = {
          PRODUCTID: this.productId,
          FORM_KIND: this.formKind,
        };
        //分批發送API
        const groupData = this.group(datas, 2000); //每組資料2千筆
        if (groupData.length == 0) {
          this.$toast.info({ title: "請確認檔案格式是否正確" });
          this.panelClose("mvMaskOpen");
          return;
        }
        let count = 0;
        let failCount = 0;
        let failMessage = "";
        this.asyncForEach(groupData, async (item, index) => {
          if (index === 0) {
            await deleteForm8Data(req).then((result) => {
              if (!(result.header && result.header.status == "200")) {
                failMessage += result.header.message;
                failCount += 1;
              }
            });
          }
          req.batchList = item;
          await batchInsertForm8(req).then((result) => {
            count += 1;
            if (!(result.header && result.header.status == "200")) {
              failCount += 1;
              failMessage += result.header.message;
            }
            if (count == groupData.length) {
              if (failCount > 0) {
                //清除已新增資料
                deleteForm8Data(req).then((result) => {
                  if (!(result.header && result.header.status == "200")) {
                    this.$toast.info({ title: failMessage });
                  }
                });
                this.$toast.info({ title: failMessage });
                this.importCount = 0;
                this.importResult = "失敗";
              } else {
                this.getForm8Data();
                this.$toast.info({ title: "Form8 匯入執行完畢" });
                this.importCount = datas.length;
                this.fileValue = "未選擇任何檔案";
                this.uploadFile = "";
                this.importResult = "成功";
              }
              this.panelClose("mvMaskOpen");
            }
          });
        });
      }
    },
    readCSV(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = (event) => {
          resolve(event.target.result);
        };
      });
    },
    //非同步ForEach
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index);
      }
    },
    //依輸入筆數進行資料分群
    group(array, subGroupLength) {
      let index = 0;
      const newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
      }
      return newArray;
    },
    //檢核檔案
    validateDatas(datas) {
      const regexSex = /^[1|2]?$/;
      const regexNumber = /^[0-9]+$/;
      const regexDecimal = /^[-+]?[0-9]+[.]?[0-9]*$/;
      datas.forEach((item, index) => {
        if (
          this.uploadFileErr.map((item) => item["no"]).indexOf(index + 1) != -1
        ) {
          return;
        }
        if (
          item.INSURE_AGE == "" ||
          (item.INSURE_AGE != "" && !regexNumber.test(item.INSURE_AGE))
        ) {
          this.uploadFileErr.push({
            no: index + 1,
            raw: this.rawArray[index],
            message: "投保年齡不可空白或格式不正確",
          });
        }
        if (
          item.YEAR == "" ||
          (item.YEAR != "" && !regexNumber.test(item.YEAR))
        ) {
          this.uploadFileErr.push({
            no: index + 1,
            raw: this.rawArray[index],
            message: "經過年度不可空白或格式不正確",
          });
        }
        if (item.SEX == "" || (item.SEX != "" && !regexSex.test(item.SEX))) {
          this.uploadFileErr.push({
            no: index + 1,
            raw: this.rawArray[index],
            message: "性別不可空白或格式不正確",
          });
        }
        if (this.formKind === "D") {
          if (
            item.GENERAL_DEATH_BENEFIT == "" ||
            (item.GENERAL_DEATH_BENEFIT != "" &&
              !regexDecimal.test(item.GENERAL_DEATH_BENEFIT))
          ) {
            this.uploadFileErr.push({
              no: index + 1,
              raw: this.rawArray[index],
              message: "一般身故保額金不可空白或格式不正確",
            });
          }
        }
        if (this.formKind !== "D") {
          if (
            item.DISEASE_DEATH_BENEFIT == "" ||
            (item.DISEASE_DEATH_BENEFIT != "" &&
              !regexDecimal.test(item.DISEASE_DEATH_BENEFIT))
          ) {
            this.uploadFileErr.push({
              no: index + 1,
              raw: this.rawArray[index],
              message: "保障金額不可空白或格式不正確",
            });
          }
        }
        if (this.formKind === "902D" || this.formKind === "D") {
          if (
            item.ACCIDENT_DEATH_BENEFIT == "" ||
            (item.ACCIDENT_DEATH_BENEFIT != "" &&
              !regexDecimal.test(item.ACCIDENT_DEATH_BENEFIT))
          ) {
            this.uploadFileErr.push({
              no: index + 1,
              raw: this.rawArray[index],
              message: "意外身故保險金不可空白或格式不正確",
            });
          }
        }
      });

      if (this.uploadFileErr.length > 0) {
        datas = datas.filter(
          (element, index) =>
            this.uploadFileErr.map((item) => item["no"]).indexOf(index + 1) ==
            -1
        );
      }

      return datas;
    },
    //查詢列表資料
    getForm8Data() {
      const req = {
        PRODUCTID: this.productId,
        FORM_KIND: ["903A", "903B", "903C"].includes(this.formKind)
          ? this.formKind
          : "",
      };
      getForm8Data(req).then((result) => {
        if (result.header && result.header.status == "200") {
          this.form8Data = result.data;
        } else {
          this.form8Data = [];
          this.$toast.info({ title: result.header.message });
        }
      });
    },
  },
  mounted() {
    this.pageName = this.$route.params.pageName;
    this.productData = JSON.parse(localStorage.productData);
    this.productId = this.productData.productId;
    this.init();
  },
};
</script>
<style scoped>
.lh-40 {
  line-height: 40px;
}
.mb-15 {
  margin-bottom: 15px;
}
.mt-40 {
  margin-top: 40px;
}
.searchArea {
  border-color: #f3a759;
  border-width: 3px;
  background-color: white;
}
.d-inline-grid {
  display: inline-grid;
}
</style>
